export { Textarea } from './Textarea';
export { renderTextarea } from './renderTextarea';
export { useTextarea } from './useTextarea';
export type { TextareaSlots, TextareaProps, TextareaState } from './Textarea.types';
